// ** React Imports
import { useEffect, useState } from 'react';

import { client } from 'src/utils/axios-client';
import {
    LeadScreenStore,
    LeadActivity,
    Lead,
    NextActivity,
    LeadActivityStore,
    ViewType,
    LeadAccountStore,
    LeadCompanyStore,
    SprintDialogStore,
    LeadSprintStore,
} from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import _ from 'lodash';
import { ActivityReady } from 'src/utils/date-utils';
import LeadDataFormater from './LeadDataFormater';
import LeadCompanyComponent from './LeadCompanyComponent';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import RadialBarChart from '../../common/RadialBarChart';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StandardSkeleton from '../../common/StandardSkeleton';
import SectionAppBar from '../../../v2/components/Section/SectionAppBar';
import CloseButton from '../../../v2/components/Button/CloseButton';

type Props = {
    onClose?: () => void;
};

const SprintDetailsView = ({ onClose }: Props) => {
    const leads = LeadSprintStore.useState((s) => s.record.sprintLeads);
    const selectedLead = LeadScreenStore.useState((s) => s.selectedLead);
    const sprintRecord = LeadSprintStore.useState((s) => s.record);
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const fetchSprintDetails = async () => {
            setHasLoaded(false);
            const response = await client.get(
                leadEndpoints.getsprintleads.replace('{sprintid}', '' + selectedLead?.sprint?.id.toString()),
            );
            LeadSprintStore.update((s) => {
                s.record = response.data;
            });
            setHasLoaded(true);
        };
        if (selectedLead != null && selectedLead.sprint != null) fetchSprintDetails();

        //if (!selectedLead) LeadAccountStore.update(s => { s = null });
    }, []);
    if (hasLoaded) {
        return (
            <>
                <SectionAppBar
                    title={'Sprint'}
                    buttons={
                        <>
                            <CloseButton onClick={onClose}>Close</CloseButton>
                        </>
                    }
                    subTitle=""
                />
                <Box>
                    <Card sx={{ mb: 6 }}>
                        <CardContent>
                            <Box>
                                <Grid container spacing={2} alignContent={'flex-end'}>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            sx={{ alignItems: 'right' }}
                                            justifyContent={'flex-end'}
                                        >
                                            <Grid item xs={12}>
                                                <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                    <Typography sx={{ fontSize: 16 }} gutterBottom>
                                                        {sprintRecord.sprintName} - Leads ({sprintRecord.leadCount})
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={6} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                        <Box display="flex" justifyContent="flex-end">
                                            <RadialBarChart
                                                subHeading="Contact Rate"
                                                seriesValue={sprintRecord.connectionRate}
                                                toolTip="Contact Rate of meanigful Interactions for this sprint"
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography variant="caption">Additional details...</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box>
                                        <Grid container spacing={2} justifyContent={'center'}>
                                            <Grid item xs={12} md={12}>
                                                <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                    <LeadDataFormater
                                                        labelText="Type:"
                                                        valueText={sprintRecord.sprintType}
                                                        textColor=""
                                                        errorText="-Unknown-"
                                                        chipHeight={20}
                                                        chipFontSize="0.75rem"
                                                        chipfontWeight={500}
                                                        isChip={false}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                    <LeadDataFormater
                                                        labelText="Status:"
                                                        valueText={sprintRecord.sprintStatus}
                                                        textColor=""
                                                        errorText="-Unknown-"
                                                        chipHeight={20}
                                                        chipFontSize="0.75rem"
                                                        chipfontWeight={500}
                                                        isChip={false}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                    <LeadDataFormater
                                                        labelText="Customer:"
                                                        valueText={sprintRecord.customerName}
                                                        textColor=""
                                                        errorText="-Unknown-"
                                                        chipHeight={20}
                                                        chipFontSize="0.75rem"
                                                        chipfontWeight={500}
                                                        isChip={false}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                    <LeadDataFormater
                                                        labelText="Start Date:"
                                                        valueText={sprintRecord.startDate}
                                                        textColor=""
                                                        errorText="-Unknown-"
                                                        chipHeight={20}
                                                        chipFontSize="0.75rem"
                                                        chipfontWeight={500}
                                                        isChip={false}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                    <LeadDataFormater
                                                        labelText="End Date:"
                                                        valueText={sprintRecord.endDate}
                                                        textColor=""
                                                        errorText="-Unknown-"
                                                        chipHeight={20}
                                                        chipFontSize="0.75rem"
                                                        chipfontWeight={500}
                                                        isChip={false}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                    <LeadDataFormater
                                                        labelText="Playbook"
                                                        valueText={sprintRecord.playbookName}
                                                        textColor=""
                                                        errorText="-Unknown-"
                                                        chipHeight={20}
                                                        chipFontSize="0.75rem"
                                                        chipfontWeight={500}
                                                        isChip={false}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        </CardContent>
                    </Card>
                    {leads.map((record) => (
                        <Card sx={{ mb: 6 }} data-testid="activity-timeline" key={record.leadId}>
                            <CardContent sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                                    <Grid
                                        item
                                        xs={6}
                                        justifyContent={'center'}
                                        alignItems={'center'}
                                        sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            sx={{
                                                pt: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Typography variant="h6">{record.leadName}</Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            sx={{
                                                pt: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <LeadDataFormater
                                                labelText=""
                                                valueText={record.jobTitle}
                                                textColor="CornflowerBlue"
                                                errorText="-Job Title is missing-"
                                                chipHeight={20}
                                                chipFontSize="0.875rem"
                                                chipfontWeight={500}
                                                isChip={false}
                                            />
                                            {record.company != null && (
                                                <LeadDataFormater
                                                    labelText="at"
                                                    valueText={record.company}
                                                    textColor="CornflowerBlue"
                                                    errorText="-Company is missing-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            sx={{
                                                pt: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                                {record.isHot && (
                                                    <Tooltip title="Is a Hot Lead">
                                                        <LocalFireDepartmentTwoTone sx={{ color: 'FireBrick' }} />
                                                    </Tooltip>
                                                )}
                                                {record.hasMI && (
                                                    <Tooltip title="Has a Meaningful Interaction">
                                                        <QuestionAnswerTwoToneIcon sx={{ color: 'LightSeaGreen' }} />
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                        justifyContent={'center'}
                                        alignItems={'center'}
                                        sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            sx={{
                                                pt: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                                <LeadDataFormater
                                                    labelText=""
                                                    valueText={record.stageName}
                                                    textColor={record.stageColor}
                                                    errorText="-Not Set-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={true}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            sx={{
                                                pt: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    {record.country != '' && (
                                                        <Tooltip title="Country">
                                                            <Typography variant="caption">{record.country}</Typography>
                                                        </Tooltip>
                                                    )}
                                                    {record.country == '' && (
                                                        <Tooltip title="Country">
                                                            <Typography variant="caption">
                                                                -Country Not Assigned-
                                                            </Typography>
                                                        </Tooltip>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            sx={{
                                                pt: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    {record.leadOwnerName != '' && (
                                                        <Tooltip title="Primary lead owner">
                                                            <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
                                                                Owner: {record.leadOwnerName}
                                                            </Typography>
                                                        </Tooltip>
                                                    )}
                                                    {record.leadOwnerName == '' && (
                                                        <Tooltip title="Primary lead owner">
                                                            <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
                                                                Owner: -Not Assigned-
                                                            </Typography>
                                                        </Tooltip>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            sx={{
                                                pt: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    {record.sprintName != '' && (
                                                        <Tooltip title="Primary lead owner">
                                                            <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
                                                                Sprint: {record.sprintName}
                                                            </Typography>
                                                        </Tooltip>
                                                    )}
                                                    {record.sprintName == '' && (
                                                        <Tooltip title="Primary lead owner">
                                                            <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
                                                                Sprint: -Not Assigned-
                                                            </Typography>
                                                        </Tooltip>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            </>
        );
    } else {
        return <StandardSkeleton />;
    }
};

export { SprintDetailsView };

export default SprintDetailsView;
